import React from 'react';
import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DocumentDataStatus from '../extractionBatches/details/DocumentDataStatus';
import StatusEditDialog from './StatusEditDialog';
import { DocumentDataStatusFilters } from '../../types/packager-types';

interface EditableDocumentDataStatusBadgeProps {
  documentId: string;
  documentDataId: string | null;
  status: DocumentDataStatusFilters | null | undefined;
  exclusionReason?: string | null;
  escalationDetail?: string | null;
}

const EditableDocumentDataStatusBadge: React.FC<EditableDocumentDataStatusBadgeProps> = ({
  documentId,
  documentDataId,
  status,
  exclusionReason,
  escalationDetail,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          position: 'relative',
          cursor: 'pointer',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleEditClick}
        data-cy={`badge-document-data-status-${documentId}`}
      >
        <DocumentDataStatus
          status={status}
          exclusionReason={exclusionReason}
          escalationDetail={escalationDetail}
        />
        <Box
          sx={{
            position: 'absolute',
            top: '-6px',
            right: '-6px',
            opacity: isHovered || open ? 1 : 0,
            pointerEvents: isHovered || open ? 'auto' : 'none',
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={() => setIsHovered(true)}
        >
          <EditIcon
            sx={{
              fontSize: '12px',
              color: '#fff',
              cursor: 'pointer',
              backgroundColor: '#65BBA9',
              borderRadius: '50%',
              padding: '2px',
              display: 'block',
              '&:hover': { backgroundColor: '#4aa897' },
            }}
            onClick={handleEditClick}
            data-cy={`btn-edit-document-data-status-${documentId}`}
          />
        </Box>
      </Box>
      <StatusEditDialog
        open={open}
        onClose={() => setOpen(false)}
        documentId={documentId}
        documentDataId={documentDataId}
        currentDocumentDataStatus={status}
        currentExclusionReason={exclusionReason}
        currentEscalationDetail={escalationDetail}
      />
    </>
  );
};

export default EditableDocumentDataStatusBadge;
